import React, { useState } from "react";
import Menu from "@material-ui/core/Menu";
import MenuItem from "@material-ui/core/MenuItem";

import Ellipsis from "../../../assets/Table/EllipsisMenu/Ellipsis.svg";
import { EllipsisMenuProps } from "./EllipsisMenu.types";
import { EllipsisContainer, Link, useStyles } from "./EllipsisMenu.styles";
import { ConfirmationModal } from "../../../components/ConfirmationModal/ConfirmationModal";
import { TableTypes } from "../Table.types";
import { useParams } from "react-router-dom";
import { useAppSelector } from "../../../store/hooks";
import { UserPermissions } from "../../../enums";
import { intersect } from "../../ProtectedRoute";

export const EllipsisMenu: React.FC<EllipsisMenuProps> = ({
  rowData,
  tableType,
  gridView,
  setPreviewId,
}) => {
  //used in the rooms version
  const { officeId } = useParams<{ officeId: string }>();
  const userPermissions = useAppSelector(state => state.auth.user.permissions);
  const rowId = (rowData.id || "") as string;
  const [ellipsis, toggleEllipsis] = useState<null | HTMLElement>(null);
  const [confirmationModalIsOpen, toggleConfirmationModal] =
    useState<boolean>(false);
  const classes = useStyles();

  const openEllipsis = (event: React.MouseEvent<HTMLElement>) => {
    toggleEllipsis(event.currentTarget);
  };

  const closeEllipsis = (event: React.MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    toggleEllipsis(null);
  };

  const handlePreviewSelect = () => {
    toggleEllipsis(null);
    if (setPreviewId) setPreviewId(rowId);
  };

  return (
    <>
      {tableType === TableTypes.Teams ? (
        <ConfirmationModal
          rowData={rowData}
          modalIsOpen={confirmationModalIsOpen}
          toggleConfirmationModal={toggleConfirmationModal}
        />
      ) : null}
      <EllipsisContainer gridView={gridView}>
        <img className="Ellipsis" src={Ellipsis} onClick={openEllipsis} />
        <Menu
          id="simple-menu"
          anchorEl={ellipsis}
          keepMounted
          open={Boolean(ellipsis)}
          onClose={closeEllipsis}
        >
          {tableType === TableTypes.Members ? (
            <section>
              <MenuItem
                classes={{ root: classes.root }}
                onClick={handlePreviewSelect}
                disabled={
                  !userPermissions.includes(UserPermissions.MemberPreview)
                }
              >
                Preview
              </MenuItem>
              <MenuItem
                classes={{ root: classes.root }}
                component={Link}
                to={`/admin/members/${rowId}/edit`}
                disabled={
                  !intersect(userPermissions, [
                    UserPermissions.MemberPreview,
                    UserPermissions.MemberViewPersonal,
                    UserPermissions.MemberViewEmployment,
                    UserPermissions.MemberViewCheckins,
                    UserPermissions.MemberViewStrengthFinder,
                    UserPermissions.MemberManagePersonal,
                    UserPermissions.MemberManageCheckins,
                    UserPermissions.MemberManageEmployment,
                    UserPermissions.MemberManageStrengthFinder,
                    UserPermissions.MemberManageTeamRoles,
                  ]).length
                }
              >
                {intersect(userPermissions, [
                  UserPermissions.MemberManagePersonal,
                  UserPermissions.MemberManageCheckins,
                  UserPermissions.MemberManageEmployment,
                  UserPermissions.MemberManageStrengthFinder,
                  UserPermissions.MemberManageTeamRoles,
                ]).length
                  ? "Edit"
                  : "View"}
              </MenuItem>
            </section>
          ) : tableType === TableTypes.Teams ? (
            <section>
              <MenuItem
                classes={{ root: classes.root }}
                component={Link}
                to={`/admin/teams/${rowId}/edit`}
                disabled={
                  !(
                    userPermissions.includes(
                      UserPermissions.TeamManageDetails
                    ) ||
                    userPermissions.includes(UserPermissions.TeamViewDetails)
                  )
                }
              >
                Edit
              </MenuItem>
              {/* <MenuItem onClick={handleDeleteSelect}>Delete</MenuItem> */}
            </section>
          ) : tableType === TableTypes.Roles ? (
            <section>
              <MenuItem
                classes={{ root: classes.root }}
                component={Link}
                to={`/admin/roles/${rowId}/edit`}
                disabled={
                  !(
                    userPermissions.includes(
                      UserPermissions.RoleManageDetails
                    ) ||
                    userPermissions.includes(UserPermissions.RoleViewDetails) ||
                    userPermissions.includes(
                      UserPermissions.RoleManagePermissions
                    )
                  )
                }
              >
                Edit
              </MenuItem>
            </section>
          ) : tableType === TableTypes.Companies ? (
            <section>
              <MenuItem
                classes={{ root: classes.root }}
                component={Link}
                to={`/admin/companies/${rowId}/edit`}
                disabled={
                  !(
                    userPermissions.includes(
                      UserPermissions.CompanyManageDetails
                    ) ||
                    userPermissions.includes(UserPermissions.CompanyViewDetails)
                  )
                }
              >
                Edit
              </MenuItem>
            </section>
          ) : tableType === TableTypes.Offices ? (
            <section>
              <MenuItem
                classes={{ root: classes.root }}
                component={Link}
                to={`/admin/offices/${rowId}/edit`}
                disabled={
                  !(
                    userPermissions.includes(
                      UserPermissions.OfficeManageDetails
                    ) ||
                    userPermissions.includes(UserPermissions.OfficeViewDetails)
                  )
                }
              >
                Edit
              </MenuItem>
            </section>
          ) : tableType === TableTypes.Rooms ? (
            <section>
              <MenuItem
                classes={{ root: classes.root }}
                component={Link}
                to={`/admin/offices/${officeId}/editRoom/${rowId}`}
                disabled={
                  !userPermissions.includes(UserPermissions.OfficeManageRooms)
                }
              >
                Edit
              </MenuItem>
            </section>
          ) : tableType === TableTypes.Dashboards ? (
            <section>
              <MenuItem
                classes={{ root: classes.root }}
                component={Link}
                to={`/dashboard/${rowId}/team`}
              >
                View Team Details
              </MenuItem>
              <MenuItem
                classes={{ root: classes.root }}
                onClick={handlePreviewSelect}
                disabled={
                  !userPermissions.includes(UserPermissions.MemberPreview)
                }
              >
                View Team Member
              </MenuItem>
            </section>
          ) : null}
        </Menu>
      </EllipsisContainer>
    </>
  );
};
